// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".node_class1{font-size:18px;@include change_size($font_size_normal)}.node_class2{font-size:16px}", ""]);
// Exports
module.exports = exports;
